import { render, staticRenderFns } from "./LoginByAccessToken.vue?vue&type=template&id=85694738&"
import script from "./LoginByAccessToken.vue?vue&type=script&lang=ts&"
export * from "./LoginByAccessToken.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports